import { render, staticRenderFns } from "./T1WelcomeSection.vue?vue&type=template&id=af9033ee&scoped=true&"
var script = {}
import style0 from "./T1WelcomeSection.vue?vue&type=style&index=0&id=af9033ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9033ee",
  null
  
)

export default component.exports